import React from 'react';
import { Calendar, CalendarDays, Clock, BookOpen } from 'lucide-react';

const ViewToggle = ({ currentView, onViewChange }) => {
  const views = [
    { id: 'month', label: 'Month', icon: Calendar },
    { id: 'week', label: 'Week', icon: CalendarDays },
    { id: 'day', label: 'Day', icon: Clock },
    { id: 'lesson-flow', label: 'Lesson Flow', icon: BookOpen }
  ];

  return (
    <div className="view-toggle">
      <div className="view-toggle-container">
        {views.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            className={`view-toggle-button ${currentView === id ? 'active' : ''}`}
            onClick={() => onViewChange(id)}
            title={`Switch to ${label} view`}
          >
            <Icon size={18} />
            <span>{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ViewToggle;

